module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/duplex-browser.js
// module id = 297
// module chunks = 8